import { ftToPx, pxToFt } from './helpers';

export function Ruler({
  direction,
  lengthPx,
  zoom,
}: {
  direction: 'horizontal' | 'vertical';
  lengthPx: number;
  zoom: number;
}) {
  const totalFeet = Math.ceil(pxToFt(lengthPx));
  const step = totalFeet > 100 ? 10 : totalFeet > 50 ? 5 : 1;
  const marks: number[] = [];
  for (let ft = 0; ft <= totalFeet; ft += step) {
    marks.push(ft);
  }

  if (direction === 'horizontal') {
    return (
      <div
        className="h-5 bg-gray-100 border-b border-gray-300 relative overflow-hidden"
        data-testid="ruler-horizontal"
      >
        {marks.map((ft) => (
          <span
            key={ft}
            className="absolute text-[8px] text-gray-500 top-1"
            style={{ left: `${ftToPx(ft) * zoom}px` }}
          >
            {ft}&apos;
          </span>
        ))}
      </div>
    );
  }

  return (
    <div
      className="w-5 bg-gray-100 border-r border-gray-300 relative overflow-hidden"
      data-testid="ruler-vertical"
    >
      {marks.map((ft) => (
        <span
          key={ft}
          className="absolute text-[8px] text-gray-500 left-0.5"
          style={{ top: `${ftToPx(ft) * zoom}px` }}
        >
          {ft}
        </span>
      ))}
    </div>
  );
}
